import { render } from "./AdminLogin.vue?vue&type=template&id=f9dd4262&scoped=true&ts=true"
import script from "./AdminLogin.vue?vue&type=script&lang=ts"
export * from "./AdminLogin.vue?vue&type=script&lang=ts"

import "./AdminLogin.vue?vue&type=style&index=0&id=f9dd4262&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9dd4262"]])

export default __exports__